module.exports = __webpack_public_path__ + "static/npckc0-346c5a7e882e572e6a5eae49663095db.png";